<template>
    <h2 class="section-header">
        <span class="section-title">
            <i v-if="icon" :class="['fad', icon, 'fa-fw', 'mr-3']"></i>{{ title }}<span v-if="count !== null && count !== undefined" class="section-count">{{ count }}</span>
        </span>
        <span class="section-actions">
            <slot/>
            <router-link v-if="to" :to="to" class="section-link">{{ linkText }} <i class="fas fa-arrow-right ml-1"></i></router-link>
        </span>
    </h2>
</template>

<script>
    // The white, dash-underlined section heading used across the student
    // app's canvas pages (Enrollments, Conference Records, Reports,
    // Dashboard), with an optional count pill and right-aligned link.
    export default {
        name: "SectionHeader",
        props: {
            title: {type: String, required: true},
            icon: {type: String, default: null},
            count: {type: Number, default: null},
            to: {type: [String, Object], default: null},
            linkText: {type: String, default: 'View all'},
        }
    };
</script>

<style lang="scss" scoped>
    .section-header {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 1rem;
        font-size: 1.2rem;
        color: white;
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);

        i {
            color: white;
        }

        .section-count {
            display: inline-block;
            margin-left: 0.6rem;
            padding: 0.05rem 0.55rem;
            border-radius: 999px;
            background: rgba(255, 255, 255, 0.18);
            font-size: 0.8rem;
            font-weight: 600;
            vertical-align: middle;
        }

        .section-actions {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            font-size: 0.85rem;
            white-space: nowrap;
        }

        .section-link {
            color: rgba(255, 255, 255, 0.8);

            &:hover {
                color: white;
                text-decoration: underline;
            }
        }
    }
</style>
